// extracted by mini-css-extract-plugin
export default {"menu":"ShipProvince_menu__jPLUz","menuItem":"ShipProvince_menuItem__YxSD9"};